import { render, staticRenderFns } from "./QrModal.vue?vue&type=template&id=b2b4ed72"
import script from "./QrModal.vue?vue&type=script&lang=js"
export * from "./QrModal.vue?vue&type=script&lang=js"
import style0 from "./QrModal.vue?vue&type=style&index=0&id=b2b4ed72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports